/* Nightpass - pop-up newsletter */
(function () {
  var DELAY = 15000;
  var KEY = 'np_pop_seen_at';
  var SNOOZE_DAYS = 30;

  function forced() {
    return window.location.search.indexOf('popup=1') !== -1;
  }

  function seenRecently() {
    try {
      var at = parseInt(window.localStorage.getItem(KEY), 10);
      if (!at) return false;
      return Date.now() - at < SNOOZE_DAYS * 86400000;
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  function init() {
    var pop = document.querySelector('[data-np-pop]');
    if (!pop || pop.dataset.ready) return;
    pop.dataset.ready = '1';

    var success = pop.getAttribute('data-success') === '1';
    var timer = null;

    function open() {
      pop.setAttribute('data-open', '1');
      document.body.style.overflow = 'hidden';
      var input = pop.querySelector('.np-pop__input');
      if (input && !success) setTimeout(function () { input.focus(); }, 320);
    }

    function close() {
      clearTimeout(timer);
      pop.setAttribute('data-open', '0');
      document.body.style.overflow = '';
      remember();
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.getAttribute('data-open') === '1') close();
    });

    /* Le contenu de la carte est remplace apres un envoi sans rechargement :
       tout ce qui s'y branche doit pouvoir se rebrancher sur les noeuds neufs.
       `np-wired` evite de doubler un ecouteur sur ceux qui ont survecu. */
    function wire() {
      pop.querySelectorAll('[data-np-pop-close]').forEach(function (el) {
        if (el.dataset.npWired) return;
        el.dataset.npWired = '1';
        el.addEventListener('click', close);
      });
      wireCopy();
    }

    /* Code promo : bouton copier, avec repli sur la selection du texte quand
       l'API presse-papiers est absente ou refusee (Safari ancien, permission). */
    function wireCopy() {
      var codeEl = pop.querySelector('[data-np-code]');
      var copyBtn = pop.querySelector('[data-np-code-copy]');
      if (!codeEl || !copyBtn || copyBtn.dataset.npWired) return;
      copyBtn.dataset.npWired = '1';
      var label = copyBtn.textContent;
      var flash = function (text) {
        copyBtn.textContent = text;
        setTimeout(function () { copyBtn.textContent = label; }, 2000);
      };
      var selectCode = function () {
        try {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } catch (e) {}
      };
      copyBtn.addEventListener('click', function () {
        var text = (codeEl.textContent || '').trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(
            function () { flash('Copi\u00e9 !'); },
            function () { selectCode(); flash('S\u00e9lectionn\u00e9'); }
          );
        } else {
          selectCode();
          flash('S\u00e9lectionn\u00e9');
        }
      });
    }

    wire();

    /* Envoi sans rechargement de la page. Shopify renvoie la page entiere ; on
       n'en garde que la carte, si bien que le code promo et les messages
       restent rendus par le serveur -- rien n'est duplique ici. Si l'appel
       echoue, on laisse le formulaire partir normalement. */
    var form = pop.closest('form');
    var card = pop.querySelector('.np-pop__card');
    if (form && card && !success) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.dataset.npSending) return;
        form.dataset.npSending = '1';

        var btn = form.querySelector('.np-pop__btn');
        var btnLabel = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Envoi...'; }

        fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-np-pop] .np-pop__card');
            if (!fresh) throw new Error('carte absente de la reponse');
            card.innerHTML = fresh.innerHTML;
            if (doc.querySelector('[data-np-pop][data-success="1"]')) {
              pop.setAttribute('data-success', '1');
              remember();
            }
            form.dataset.npSending = '';
            wire();
          })
          .catch(function () {
            form.dataset.npSending = '';
            if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
            form.submit();
          });
      });
    }

    /* Ouverture manuelle (bouton de la banniere) : ignore la mise en sommeil */
    window.NPPopupOpen = open;
    window.NPPopupClose = close;

    if (success) { remember(); open(); return; }
    if (forced()) { open(); return; }
    if (seenRecently()) return;

    timer = setTimeout(open, DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
